export const getNextUnreadCount = (
    currentUnreadCount: number | undefined,
    isIncoming: boolean,
    isActiveChat: boolean
): number => {
    const unreadCount = Math.max(0, Number(currentUnreadCount) || 0);

    if (!isIncoming) return unreadCount;
    return isActiveChat ? 0 : unreadCount + 1;
};
